export const isLoading = (state) => state.isLoading;
